module.exports = __webpack_public_path__ + "img/MottoCenter-D-TOOLS-Rep.e99dd9d3.png";